<template>
	<div style="margin-top: 20px">
		<div class="col-xs-4 text-right" style="margin-top: 30px">
			<img style="width: 40%" src="../../../../clientes/cm-bahia/governo-do-estado.png" alt="Governo do Estado BA" />
		</div>

		<div class="col-xs-4 text-center" style="margin-top: 30px; margin-bottom: 15px; letter-spacing: 1.5px">
			<p>
				GOVERNO DO ESTADO DA BAHIA <br />
				CASA MILITAR DO GOVERNADOR <br />
				DIRETORIA DE AVIAÇÃO
			</p>
		</div>

		<div class="col-xs-4 text-left" style="margin-top: 20px">
			<img style="width: 20%" src="../../../../clientes/cm-bahia/brasao-casa-militar.png" alt="Brasão casa militar BA" />
		</div>
	</div>
</template>
<script>
export default {}
</script>
<style></style>
